// Core imports
import * as React from 'react';
import PartClaimService from 'src/services/partClaim/partClaimService';
import { goToHome, goToPartClaim } from 'src/utils/navigation';

// Components imports
import PartClaimForm from 'src/components/PartClaimForm';

// Models imports

// Style and misc imports
import './PartClaimView.scss';
import logo from 'src/assets/mainLogo';
import statusError from 'src/assets/statusError';
import PartClaimFormCA from '../../components/PartClaimFormCA';
import env from 'src/shared/env';
import { error } from 'util';

class PartClaimView extends React.Component<
  IPartClaimViewProps,
  IPartClaimViewState
> {
  constructor(props: IPartClaimViewProps) {
    super(props);

    this.state = {
      claimNumber: 0,
      succed: false,
      failed: false,
      errors: []
    };
  }

  public componentDidMount = () => {
    PartClaimService.getClaimNumber().then((claimNumber: any) => {
      this.setState({ claimNumber: claimNumber.data });
    });
  };

  private onSuccess = () => {
    this.setState({ succed: true });
  };

  private onFailed = (message: string, statusObj: any) => {
    const errors = this.handleErrorMessages(message);
    this.setState(prevState => ({
      failed:
        statusObj?.status === false || statusObj?.status === true
          ? statusObj.status
          : !prevState.failed,
      errors
    }));
  };

  private mapValidationVariable = (message: string) => {
    const errors = [
      { name: 'partFailedDate', label: 'Date Parts Failed' },
      { name: 'partInstalledDate', label: 'Date Parts Installed' },
      { name: 'warrantyClaimDetails', label: 'Part Number' },
      { name: 'partNumber', label: 'Part Number' }
    ];
    let newMessage = '';
    errors.map(err => {
      if (message.includes(err.name)) {
        newMessage = message.replace(err.name, err.label);
      }
      return;
    });
    return newMessage;
  };

  private handleErrorMessages = (message: string) => {
    const errors = message.split('\n');
    const formatedErrs = errors.map(err => {
      return this.mapValidationVariable(err);
    });

    return formatedErrs;
  };

  private renderConfirmation = () => {
    return (
      <React.Fragment>
        <div className="rp-part-claim--confirmation">
          <div className="rp-part-claim--confirmation-info">
            <i className="rpds-check-circle rp-part-claim--success-icon-desktop" />
            <div>
              <div className="rp-part-claim--confirmation-title">
                Your claim submission has been sent.
              </div>
              <i className="rpds-check-circle rp-part-claim--success-icon-mobile" />
              <p className="rp-part-claim--confirmation-description">
                Thank you! You will be contacted by a Reliable Parts Customer
                Service Representative soon.
              </p>
            </div>
          </div>
          <div className="rp-part-claim-divider" />
          <button
            onClick={e => goToHome()}
            className="primary-button rp-part-claim--confirmation-buttons"
          >
            Go Home
          </button>
        </div>
      </React.Fragment>
    );
  };

  private renderErrors = (errors: string[]) => {
    const err: JSX.Element[] = [];
    errors.map(msg => {
      err.push(<span className="rp-part-claim--error-message">{msg}</span>);
    });
    return err;
  };

  private renderFailed = () => {
    setTimeout(() => {
      window.scrollTo(0, 300);
    });
    return (
      <React.Fragment>
        <div className="rp-part-claim--error">
          {/* <div className="rp-part-claim-divider" /> */}
          <div className="rp-part-claim--error-info">
            <img
              src={statusError}
              className="rp-modal-payment-status--img"
              width="100"
            />
            <div className="rp-part-claim-error-container">
              <div className="rp-part-claim--error-title">
                There was an error submitting your claim. Please review the
                errors listed below and try again.
              </div>
              <div>{this.renderErrors(this.state.errors)}</div>
              <i className="rpds-check-circle rp-part-claim--error-icon-mobile" />
            </div>
          </div>
          {/* <div className="rp-part-claim--error-return-container">
            <span
              onClick={e => this.onFailed('')}
              className="rp-part-claim--error-buttons"
            >
              Try Again
            </span>
          </div> */}
        </div>
      </React.Fragment>
    );
  };

  public renderUSVersion() {
    const { t } = this.props;

    return (
      <div className="rp-part-claim--container">
        <img src={logo} className="logo" alt="reliable parts logo" />
        <span className="part-submission">
          {t('partClaim.partsOnlySubmission')}
        </span>
        <span className="required-info">({t('partClaim.requiredInfo')})</span>
        <span className="claim-info">
          {t('partClaim.partsClaimInformation')}
        </span>
        <div className="manufacturer-claim">
          <p className="eia">
            <span className="label">{t('partClaim.EiaManufacturerId')}</span>
            <span className="value">1550</span>
          </p>
          <p className="reference">
            <span className="label">{t('partClaim.referenceClaimNumber')}</span>
            <span className="value">{this.state.claimNumber}</span>
          </p>
        </div>
        <div />
        {this.state.failed ? this.renderFailed() : ''}
        <PartClaimForm
          claimNumber={this.state.claimNumber}
          onSuccess={this.onSuccess}
          onFailed={this.onFailed}
        />
        {/* {this.state.failed ? (this.renderFailed(), window.scrollTo(0, 0)) : ''} */}
      </div>
    );
  }

  public renderCAVersion() {
    const { t } = this.props;

    return (
      <div className="rp-part-claim--container">
        <img src={logo} className="logo" alt="reliable parts logo" />
        <span className="part-submission">
          {t('partClaim.warrantyClaimForm')}
        </span>
        <span className="required-info">({t('partClaim.requiredInfo')})</span>
        <span className="claim-info">
          {t('partClaim.partsClaimInformation')}
        </span>
        <div />
        {this.state.failed ? this.renderFailed() : ''}
        <PartClaimFormCA
          claimNumber={this.state.claimNumber}
          onSuccess={this.onSuccess}
          onFailed={this.onFailed}
        />
      </div>
    );
  }

  public render() {
    const { t } = this.props;

    return (
      <section id="rp-part-claim">
        <React.Fragment>
          {this.state.succed
            ? this.renderConfirmation()
            : env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? this.renderCAVersion()
            : this.renderUSVersion()}
        </React.Fragment>
      </section>
    );
  }
}

export default PartClaimView;

interface IPartClaimViewProps {
  t: any;
}

interface IPartClaimViewState {
  claimNumber: number;
  succed: boolean;
  failed: boolean;
  errors: string[];
}
